var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.brand)?_c('h1',{staticClass:"company-brand"},[_vm._v(" "+_vm._s(_vm.brand)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }